import { ReactElement, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { joinState, PlayerJoinState } from '../../api/stores';
import { initializeConnectionEvents } from '../../api/stores/events';
import { startJoin } from '../../api';
import { Player } from '../player/Player';
import { WhyPlaycast } from '../components/WhyPlaycast';
import { useAuth0 } from '@auth0/auth0-react';
import { authStateStore } from '../../api/stores';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { sendMetricPlayerAuthenticate } from '../../metrics';
import { SignedIn, SignedOut, SignInButton, UserButton } from '@clerk/clerk-react';
import { Button } from '@playcastdotio/Shadcn';
import { Privacy } from '@playcastdotio/Settings';
import { Invitation } from './JoinPages/Invitation2';
import { Deck } from './JoinPages/Deck2';
import { DisconnectedHost } from './JoinPages/DisconnectedHost2';
import { DisconnectedPlayer } from './JoinPages/DisconnectedPlayer2';
import { Queue } from './JoinPages/Queue2';

export const Joiner = () => {
  const { joinId } = useParams();
  const [currentState, setCurrentState] = useState<PlayerJoinState['state']>('idle');
  const { getAccessTokenSilently, user, isAuthenticated, getIdTokenClaims } = useAuth0();

  useEffect(() => {
    const fetchTokens = async () => {
      try {
        const token = await getAccessTokenSilently();
        const claims = await getIdTokenClaims();
        // const id_token = claims?.__raw;
        // const idToken = user?.id_token;
        authStateStore.updateState({
          accessToken: token,
          email: user?.email || '',
          playerAuthId: user?.sub || '',
        });
      } catch (error) {
        console.error('Error fetching tokens:', error);
      }
    };

    if (isAuthenticated) {
      fetchTokens();
      sendMetricPlayerAuthenticate(user?.sub || '');
    }
  }, [isAuthenticated, getAccessTokenSilently, user, getIdTokenClaims]);

  useEffect(() => {
    initializeConnectionEvents();
    const stateListener = joinState.addListener((state) => {
      setCurrentState(state.state);
      console.log('Joiner state:', state);
    });
    setCurrentState(joinState.currentState.state);
    console.log('Joiner state:', joinState.currentState);
    if (joinState.currentState.state === 'idle') {
      startJoin(joinId);
    }
    return () => {
      joinState.removeListener(stateListener);
    };
  }, [joinId]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // console.log('Pop state:', event.state);
      const stage = event.state?.stage;
      if (stage) {
        switch (stage) {
          case 'idle':
            joinState.updateState({ state: 'idle' });
            break;
          case 'chooseDeck':
            joinState.updateState({ state: 'chooseDeck' });
            break;
        }
      }
    };

    window.history.pushState({ stage: 'idle' }, '');

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // we want to switch on the state here
  return (
    <>
      {(() => {
        switch (currentState) {
          case 'idle':
            return (
              <Wrapper>
                <p></p>
              </Wrapper>
            );
          case 'resolvingAlias':
            return (
              <Wrapper>
                <Connecting />
              </Wrapper>
            );
          case 'chooseDeck':
            return (
              <div className='bg-hero bg-content text-content-text xs:h-screen m-0 h-full w-full bg-cover bg-no-repeat p-0 sm:h-screen md:h-screen lg:h-full'>
                <div className='container mx-auto h-auto w-full px-8 py-10'>
                  <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
                    <div className='col-span-full flex flex-grow flex-row items-center justify-center gap-x-2 pt-3 align-middle'>
                      <img src='/images/playcast_logo-96x96.png' alt='Logo' className='h-12 w-12' />
                      <h1 className='text-content-text-headline font-headline text-3xl font-bold md:pt-2'>
                        <Link to='https://playcast.io'>Playcast</Link>
                      </h1>
                    </div>
                  </section>
                  <Deck />
                </div>
              </div>
            );
          case 'chooseInvite':
            return (
              <Wrapper>
                <Invitation />
              </Wrapper>
            );
          case 'connecting':
            return (
              <Wrapper>
                <Connecting />
              </Wrapper>
            );
          case 'hostConnected':
            return <Player />;
          case 'hostDisconnected':
            return (
              <Wrapper>
                <DisconnectedHost />
              </Wrapper>
            );
          case 'inQueue':
            return <Queue />;
          case 'playerDisconnected':
            return (
              <Wrapper>
                <DisconnectedPlayer />
              </Wrapper>
            );
          case 'playerKicked':
            return (
              <Wrapper>
                <div className='mt-8 flex flex-col items-center gap-14'>
                  <div className='bg-footer w-full space-y-4 rounded-lg p-4 py-6 text-center shadow-md md:w-2/3 lg:w-2/5'>
                    <h3 className='row-auto text-2xl font-bold'>Lobby Update</h3>
                    <p className='text-md row-auto text-center font-normal'>You have been kicked from the lobby</p>
                  </div>
                </div>
              </Wrapper>
            );
        }
      })()}
    </>
  );
};

const Wrapper = (props: { children: ReactElement }) => {
  return (
    <>
      <div className='bg-hero bg-content text-content-text m-0 h-screen w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto h-auto w-full px-8 py-10'>
          <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
            <div className='col-span-full flex flex-grow flex-row items-center justify-center gap-x-2 pt-3 align-middle'>
              <img src='/images/playcast_logo-96x96.png' alt='Logo' className='h-12 w-12' />
              <h1 className='text-content-text-headline font-headline text-3xl font-bold md:pt-2'>
                <Link to='https://playcast.io'>Playcast</Link>
              </h1>
            </div>
          </section>
          {props.children}

          {/* Optional Login */}
          {/* <div className='flex flex-1 flex-col items-center justify-center space-y-4 p-2'>
            <SignedOut>
              <h5 className='pt-12 text-xs'>Optionally, log in below</h5>
              <SignInButton mode='modal'>
                <Button className='rounded-full px-12'>Login</Button>
              </SignInButton>
            </SignedOut>
            <SignedIn>
              <div className='flex flex-col items-center space-y-2 pt-12 text-xs'>
                <span>Logged in as: </span>
                <UserButton
                  showName
                  appearance={{
                    elements: {
                      userButtonTrigger: 'h-10 focus:!h-10 bg-primary rounded-full',
                      userButtonBox: 'flex flex-row-reverse gap-2 px-2',
                      userButtonAvatarBox: 'size-7',
                      userButtonPopoverActionButton: 'text-white',
                      userButtonOuterIdentifier: 'p-0 text-gray-900 text-md font-semibold',
                    },
                  }}
                >
                  <UserButton.UserProfilePage
                    label='Privacy'
                    url='privacy'
                    labelIcon={
                      <div>
                        <FontAwesomeIcon icon={faLock} className='text-md' />
                      </div>
                    }
                  >
                    <div className='h-100 flex flex-col gap-y-2'>
                      <Privacy />
                    </div>
                  </UserButton.UserProfilePage>
                </UserButton>
              </div>
            </SignedIn>
          </div> */}
        </div>
      </div>
      <WhyPlaycast />
    </>
  );
};

const Connecting = () => {
  return (
    <div className='absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 transform'>
      <FontAwesomeIcon className='size-10 animate-spin' icon={faSpinner} />
    </div>
  );
};
